


//--- document ready start ---- 
$(document).ready(function () {
  
    // $("#pre-loading").fadeOut(2000);


    $('body').on('click', '.filter_plus', function (event) {
        event.stopPropagation();
        var $valueElement = $(this).next();
        var value = $valueElement.text();
        var newValues = parseInt(value, 10);
        newValues = isNaN(newValues) ? 0 : newValues;

        newValues++;
        $valueElement.text(newValues);
        console.log(newValues);
        $(this).parent().find('.filter-qnty-value ').val(newValues);
    });

    $('body').on('click', '.filter_minus', function (event) {
        event.stopPropagation();
        var $valueElement = $(this).prev();
        var value = $valueElement.text();
        var newValues = parseInt(value, 10);
        newValues = isNaN(newValues) ? 0 : newValues;

        if (newValues > 0) {
            newValues--;
            $valueElement.text(newValues);
            $(this).parent().find('.filter-qnty-value ').val(newValues);
        }
    });


    //------banner filter section end----------




//---------product form on collection page----------
// Disabled: collection quick popup (was causing JS errors / not used anymore).
// Button was replaced with <a href="..."> so users go to product page directly.

(function () {
  // If legacy markup doesn't exist, do nothing (prevents runtime errors)
  var coll_modal = document.getElementById("coll_popup_modal");
  var coll_inner = document.getElementById("coll_popup_inner");
  if (!coll_modal || !coll_inner) return;

  // If you ever re-enable this feature, restore the old handlers here.
})();

//------product from on collection page end----------




    



    $(document).on('click', '.close_upsell_popup', function () {
        $('#main_popup_container').fadeOut();
        $('body').removeClass('showing-custom-popup');
    });


    $('body').on('click', '.item_popup_msg', function () {
        var popup_content = $(this).parent().find('.popup_msg_content').val();
        $('.item_msg_modal').find('.main_inner_content').html(popup_content);
      if(popup_content){
        $('body').addClass('showing-custom-popup')
        $('#item_msg_modal').show();
      }
        
    });


    $('body').on('click', '.qusmark_popup', function () {
        var popup_content = $(this).parent().next().val();
        $('.item_msg_modal').find('.main_inner_content').html(popup_content);
      if(popup_content){
        $('#item_msg_modal').show();
        $('body').addClass('showing-custom-popup')
      }
    });


    $('body').on('click', '.item_msg_close', function () {
        $('#item_msg_modal').hide();
        $('body').removeClass('showing-custom-popup');
    });



    //------------ Window popup close --------  
var modal = document.getElementById("main_popup_container");
var item_msg_modal = document.getElementById("item_msg_modal");
var location_modal = document.getElementById("location_tracker_inner");
var available_location_msg = document.getElementById("available_location_msg");
var load_delivery_location = document.getElementById("delivery-location-main");
var selected_location = document.getElementById("selected-location-msg");
var time_selectbox_sec = document.getElementById("time-selectbox-sec");

window.onclick = function (event) {
  // Legacy collection popup modal (may be removed from DOM)
  // Keep as global so window.onclick doesn't crash
  var coll_modal = document.getElementById("coll_popup_modal");

  if (event.target == load_delivery_location) {
    $(load_delivery_location).fadeOut();
  }
  else if (event.target == selected_location) {
    $(selected_location).fadeOut();
  }
  else if (coll_modal && event.target == coll_modal) {
    $(coll_modal).fadeOut();
    $('body').removeClass('body_fixed');
  }
  else if (event.target == item_msg_modal) {
    $(item_msg_modal).hide();
    $('body').removeClass('showing-custom-popup');
  }
  else if (event.target == modal) {
    $(modal).fadeOut();
    $('body').removeClass('showing-custom-popup');
  }
  else if (event.target == location_modal) {
    $('#location_tracker_inner').removeClass('show_location_track');
  }
  else if (event.target == available_location_msg) {
    $(available_location_msg).fadeOut();
    $('body').removeClass('showing-custom-popup');
  }
  else if (event.target == time_selectbox_sec) {
    $(time_selectbox_sec).fadeOut();
    $('body').removeClass('showing-custom-popup');
  }
};


        //-----Header Scroll menu ----

    function updateHeaderScrollButtons($menu) {
        if (!$menu.length || !$menu[0]) return;

        var scrollLeft = $menu.scrollLeft();
        var clientWidth = $menu.outerWidth();
        var scrollWidth = $menu[0].scrollWidth;

        var hasOverflow = scrollWidth > clientWidth + 2;

        var $prevBtn = $menu.children('.prev_btn');
        var $nextBtn = $menu.children('.next_btn');

        if (!hasOverflow) {
            $prevBtn.hide().prop('disabled', true);
            $nextBtn.hide().prop('disabled', true);
            return;
        }

        if (scrollLeft <= 2) {
            $prevBtn.hide().prop('disabled', true);
        } else {
            $prevBtn.show().prop('disabled', false);
        }

        if (scrollLeft + clientWidth >= scrollWidth - 2) {
            $nextBtn.show().prop('disabled', true);
        } else {
            $nextBtn.show().prop('disabled', false);
        }
    }

    function initHeaderScrollMenus() {
        $('.horizontal_scroll_menu ul.parent-menu-scroll, .horizontal_scroll_menu ul.child-menu-scroll').each(function () {
            var $menu = $(this);

            $menu.off('scroll.headerScroll').on('scroll.headerScroll', function () {
                updateHeaderScrollButtons($(this));
            });

            updateHeaderScrollButtons($menu);
        });
    }

    initHeaderScrollMenus();

    $(window).on('load resize', function () {
        initHeaderScrollMenus();
    });

    $('body').on('click', '.next_btn', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $menu = $(this).closest('ul.parent-menu-scroll, ul.child-menu-scroll');
        if (!$menu.length) return;

        $menu.stop().animate(
            { scrollLeft: $menu.scrollLeft() + 220 },
            400,
            function () {
                updateHeaderScrollButtons($menu);
            }
        );
    });

    $('body').on('click', '.prev_btn', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $menu = $(this).closest('ul.parent-menu-scroll, ul.child-menu-scroll');
        if (!$menu.length) return;

        $menu.stop().animate(
            { scrollLeft: $menu.scrollLeft() - 220 },
            400,
            function () {
                updateHeaderScrollButtons($menu);
            }
        );
    });



        $('body').on('click', '.horizontal_scroll_menu ul li span.link--text', function (e) {
        e.stopPropagation();

        var $li = $(this).closest('li');
        var $el = $li.find('.first_menu_child, .second_menu_child').first();

        $('.horizontal_scroll_menu ul > li > .first_menu_child, .horizontal_scroll_menu ul > li > .second_menu_child')
            .not($el)
            .slideUp();

        $('.horizontal_scroll_menu ul > li > span.link--text').not(this).removeClass('active');

        $el.slideToggle();
        $(this).toggleClass('active');

        setTimeout(function () {
            initHeaderScrollMenus();
        }, 250);
    });


    $('body').on('change', '.desktop_switch_btns input , .mobile_switch_btns input', function () {
        var show_menu = $(this).attr('data-val');
       //  console.log(show_menu);
        if (show_menu == 'show_first_menu') {
            window.location.href = "/";
        } else {
            window.location.href = "/pages/zakelijk-bestellen";
        }
                
        if (localStorage.getItem('AccountType')) {
            localStorage.removeItem('AccountType');
        }
        localStorage.setItem('AccountType', show_menu);

      
    });

    $('body').on('change', '#private_business', function () {
        if (this.value == "Particulier") {
            $('.for_business').hide();
            $('.for_private').show();
        } else {
            $('.for_private').hide();
            $('.for_business').show();
        }
    });

    $('body').on('click', '.mobile_search_icon.mobile_header', function () {
        $('.mobile_search_form').show();
        $('#search-mobile').focus();
    });

    $('body').on('click', '.mobile_search_icon.mobile_menu', function () {
        $('.mobile_search_form').show();
        $('.main_drawe_mobile_menu').find('#search-mobile').focus();
    });


    $('body').on('click', '.mobile_search_form button[title="Cancel search"], .mobile-header-close-search', function () {
        $('.mobile_search_form').hide();
    });
  
    $(document).on('click', function (event) {
        if (!$(event.target).closest('.mobile_menu_search ,.mobile_search_icon.mobile_header,.mobile_search_form').length) {
             $('.mobile_search_form').hide();
        }
    });

    $('body').on('click', '.top_checkout #checkout', function (event) {
       event.stopPropagation();
      event.preventDefault();
        window.location.href = "/checkout";
     });




//*----    NEW Version-3 -----*

$('body').on('click', '.switch_btn_dropdown', function () {
      $(".switch-field.desktop_switch_btns").slideToggle();
      $(this).toggleClass('active');
});
  
$('body').on('click', '.new-desktop-search', function () {
      $(".header_right_icons .desktop-search span").trigger('click');
});

  $(".delivery-icons").mouseover(function(){
    $(".tooltip_popup").show();
  });
  $(".delivery-icons").mouseout(function(){
    $(".tooltip_popup").hide();
  });
  
$('body').on('click', '.tooltip_popup .close-icon', function () {
      $(".tooltip_popup").hide();
});
  


    //--- document ready close ---- 
});



